import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/img/hamburger-black.png'
import _imports_1 from '@/assets/img/hamburger-white.png'


const _hoisted_1 = { class: "float-right visible lg:hidden" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  class: "hamburger-black-display",
  src: _imports_0,
  width: "35",
  alt: "menu-bar"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "hamburger-white-display",
  src: _imports_1,
  width: "35",
  alt: "menu-bar"
}, null, -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "menu-font flex flex-col justify-center items-center mt-10 gap-8 dark:text-black" }
const _hoisted_7 = { class: "menu-font flex flex-row justify-end items-center gap-8 invisible lg:visible" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: "p-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.drawer = true))
        }, _hoisted_5)
      ]),
      _createVNode(_component_el_drawer, {
        modelValue: _ctx.drawer,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.drawer) = $event)),
        title: "I am the title",
        direction: "ltr",
        "with-header": false,
        size: "70%",
        "custom-class": "drawer-bg"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.drawer = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.home')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/how-we-work",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.drawer = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.how_we_work')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/about",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drawer = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.about_us')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/contact",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.drawer = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.contact')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: `/events/${_ctx.selectedYear}`,
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.drawer = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.event')), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createVNode(_component_router_link, {
              to: "/career",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.drawer = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('nav.career')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_select, {
              modelValue: _ctx.value,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.value) = $event)),
              class: "select-language"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.value,
                    label: item.label,
                    value: item.value,
                    onClick: ($event: any) => (_ctx.switchLocale(item.value))
                  }, null, 8, ["label", "value", "onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_el_switch, {
              modelValue: _ctx.isDark,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.isDark) = $event)),
              size: "large",
              "active-text": "Dark",
              "inactive-text": "Light",
              "active-color": "white",
              "inactive-color": "black"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: "/" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.home')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: "/how-we-work" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.how_we_work')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: "/about" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.about_us')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: "/contact" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.contact')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, {
          to: `/events/${_ctx.selectedYear}`
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.event')), 1)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_router_link, { to: "/career" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('nav.career')), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_el_select, {
          modelValue: _ctx.value,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.value) = $event)),
          class: "select-language"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.value,
                label: item.label,
                value: item.value,
                onClick: ($event: any) => (_ctx.switchLocale(item.value))
              }, null, 8, ["label", "value", "onClick"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_component_el_switch, {
        modelValue: _ctx.isDark,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.isDark) = $event)),
        size: "large",
        "inline-prompt": "",
        "active-color": "white",
        "inactive-color": "black"
      }, null, 8, ["modelValue"])
    ])
  ], 64))
}